import { render, staticRenderFns } from "./DonationFaq.vue?vue&type=template&id=5bc05652&scoped=true"
import script from "./DonationFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationFaq.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DonationFaq.vue?vue&type=style&index=0&id=5bc05652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc05652",
  null
  
)

export default component.exports